import styled from 'styled-components';

import { FlexBox, system, SystemProps } from '@sternum/styled-system';
import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

export const Line = styled(FlexBox)<SystemProps>`
  display: flex;
  flex: 1;
  gap: 8px;
  width: 100%;
  height: 1px;
  background-color: ${ct({ Dark: Colors.GreyLightest, Light: Colors.GreyLightest })};

  ${system};
`;

export const Title = styled.div`
  color: ${ct({ Dark: Colors.GreyDarker, Light: Colors.GreyDarker })};
  font-size: 12px;
  font-weight: 400;
  margin: 0 8px;
`;

export const TimeSeparatorStyled = styled(FlexBox)<SystemProps>`
  align-items: center;
  height: 34px;

  ${system};
`;
